import "./ProfPage.css";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  InputGroup,
  Container,
  Row,
  Form,
  Button,
  Offcanvas,
} from "react-bootstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { registerUser } from "../../../Auth/authServices";
import { ToastContainer, toast } from "react-toastify";
import {
  collection,
  doc,
  onSnapshot,
  query,
  setDoc,
  Timestamp,
} from "firebase/firestore";
import { db } from "../../../../Firebase";
import CardProf from "../../../../Component/cardProf/CardProf";

import { useEffect } from "react";
import { Link } from "react-router-dom";
import { LISTE_ARCHIVE_NAVIGATION } from "../../../../Routes/NAVIGATION_PATH";
import PaginationContainer from "../../../../Component/PaginationContainer/PaginationContainer";

function ProfPage() {
  const [allProfs, setAllProfs] = useState([]);
  const [show, setShow] = useState(false);

  const reftab = query(collection(db, "users"));
  const getUsers = () => {
    onSnapshot(reftab, (item) => {
      const currentUserId = sessionStorage.getItem("user_id");
      const data = [];
      item.forEach((i) => {
        data.push({ ...i.data(), id: i.id });
      });

      setAllProfs(
        data.filter(
          (elts) =>
            elts.user_type === "prof" &&
            elts.admin_id === currentUserId &&
            elts.isArchived === false
        )
      );
    });
  };

  useEffect(() => {
    getUsers();
  }, []);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const user_id = sessionStorage.getItem("user_id");

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors }
  } = useForm();

  const user_type = "prof";

  const onSubmit = (data) => {
    const { nom, prenom, email, domaine, tel } = data;
    const password = "123456";
    registerUser(email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        setDoc(doc(db, "users", user.uid), {
          ...data,
          user_type: "prof",
          isArchived: false,
          admin_id: user_id,
          registeredAt: Timestamp.fromDate(new Date()),
        });
        reset();
        handleClose();
        toast.success("Prof ajouté avec succès!");
      })
      .catch((error) => {
        const errorCode = error.code;
        if (errorCode === "auth/email-already-in-use") {
          toast.error("Utilisateur existant !");
          reset();
        } else if (errorCode === "auth/weak-password") {
          toast.warning("Mot de passe faible, utlisez minimum 6 caractères !");
        } else if (errorCode === "email-already-in-use") {
          toast.warning("Email déjà utiliser !");
        } else if (errorCode === "auth/invalid-email") {
          toast.error("Adresse Email non valide !");
        }
      });
  };
  /*-------------------filtre -------------*/

  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = allProfs.filter(
    (elt) =>
      elt?.nom?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      elt?.prenom?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      elt?.domaine?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      elt?.residence?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      elt?.email?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      elt?.tel?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const handelTermChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const myDatas = searchTerm === "" ? allProfs : filteredData;
  return (
    <div className="prof-page">
      <Container>
        <div className="d-flex justify-content-between">
          <div>
            <Link
              to={`${LISTE_ARCHIVE_NAVIGATION}${user_type}`}
              className="btn btnm text-white fw-bold"
            >
              Mes archives
            </Link>
          </div>
          <div className="d-flex justify-content-end ajouRecher">
            <input
              style={{ width: "25% !important" }}
              type="text"
              onChange={handelTermChange}
              value={searchTerm}
              className="form-control"
              id="exampleInputEmail1"
              placeholder="Recherche cours"
              aria-describedby="emailHelp"
            />
            <div className="cont-btn-aj  d-flex ">
              <Button variant="primary" className="btnk" onClick={handleShow}>
                Ajouter Professeurs
              </Button>
            </div>
            <Offcanvas show={show} onHide={handleClose} placement="end">
              <Offcanvas.Header closeButton>
                <Offcanvas.Title className="text-uppercase">
                  Ajouter un professeur
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Nom</Form.Label>
                    <Form.Control
                      {...register("nom", {
                        required: true,
                        maxLength: 15,
                        pattern: /^[A-Za-z\s]+$/i
                      })}
                      type="text"
                      placeholder="Nom du prof"
                    />
                    {errors?.nom?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
                    {errors?.nom?.type === "maxLength" && (
                      <p className="text-danger">La longueur maximal est de 15 lettres</p> 
                    )}
                    {errors?.nom?.type === "pattern" && (
                      <p className="text-danger">Il ne prend que des lettres alphabétiques </p>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Prénom</Form.Label>
                    <Form.Control
                      {...register("prenom", {
                        require: true,
                        maxLength: 25,
                        pattern: /^[A-Za-z\s]+$/i
                      })}
                      type="text"
                      placeholder="Prénom du prof"
                    />
                    {errors?.prenom?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
                    {errors?.prenom?.type === "maxLength" && (
                      <p className="text-danger">La longueur maximal est de 25 lettres</p>
                    )}
                    {errors?.prenom?.type === "pattern" && (
                      <p className="text-danger">Il ne prend que des lettres alphabétiques </p>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Téléphone</Form.Label>
                    <Form.Control
                      {...register("tel", {
                        require: true,
                        maxLength: 9,
                        pattern: /^7[0,5,6,7,8]\d+$/
                      })}
                      type="tel"
                      placeholder="Numéro de télephone"
                    />
                    {errors?.tel?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
                    {errors?.tel?.type === "maxLength" && (
                      <p className="text-danger">un numéro de téléphone comporte 9 chiffres</p>
                    )}
                    {errors?.tel?.type === "pattern" && (
                      <p className="text-danger">Il ne prend que des chiffres commençant par 70, 75, 76, 77 ou 78 </p>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Résidence</Form.Label>
                    <Form.Control
                      {...register("residence", { require: true, maxLength: 20 })}
                      type="text"
                      placeholder="Residence du prof"
                    />
                    {errors?.residence?.type === "maxLength" && (
                      <p className="text-danger">La longueur maximal est de 20 lettres</p>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      {...register("email", {
                        require: true, maxLength: 25,
                        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                      })}
                      type="email"
                      placeholder="Mail du prof"
                    />
                    {errors?.email?.type === "maxLength" && (
                      <p className="text-danger">La longueur maximal est de 25 lettres</p>
                    )}
                    {errors?.email?.type === "pattern" && (
                      <p className="text-danger">Entrez un email valide</p>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Domaine du prof</Form.Label>
                    <Form.Select {...register("domaine", { require: true })}>
                      <option value="programmation">Programmation</option>
                      <option value="design">Design</option>
                      <option value="marketing digital">
                        Marketing Digital
                      </option>
                      <option value="gestion de projet">
                        Gestion de projet
                      </option>
                    </Form.Select>
                  </Form.Group>
                  <Button
                    type="reset"
                    className="me-2"
                    onClick={handleClose}
                    variant="danger"
                  >
                    Annuler
                  </Button>
                  <Button variant="success" type="submit">
                    Ajouter
                  </Button>
                </Form>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </div>
      </Container>

      <Container>
        <Row>
          <PaginationContainer
            data={myDatas}
            ItemComponent={CardProf}
            itemsPerPage={6}
          />
        </Row>
      </Container>
    </div>
  );
}

export default ProfPage;
